// @core/api/endpoints/subscription/get_feature_usage.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetFeatureUsageResponse,
} from '../../../types/subscription';

const BASE_PATH = '/subscription';

/**
 * Get feature usage
 * Returns current feature usage for the subscription with breakdown by feature, comparison to limits, and historical data.
 */
export async function GetFeatureUsage(
  subscription_id: string,
  options?: RequestOptions
): Promise<GetFeatureUsageResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/subscriptions/:subscription_id/usage`;
  requestPath = requestPath.replace(':subscription_id', encodeURIComponent(subscription_id));
  const requestOptions = options;
  return client.get<GetFeatureUsageResponse>(requestPath, { ...requestOptions });
}
